var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsGrcPlatforms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02983 5.23362L6.20863 6.06821L2.68212 7.7018C2.60726 7.73635 2.60402 7.84155 2.67661 7.88064L8.02433 10.7602C8.05393 10.7761 8.08955 10.7761 8.11915 10.7602L13.4669 7.88064C13.5395 7.84155 13.5362 7.73635 13.4614 7.7018L9.93486 6.06821L8.11365 5.23362C8.08706 5.22135 8.05642 5.22135 8.02983 5.23362Z",
    fill: "#4C5E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02983 8.94791L2.68212 11.4161C2.60726 11.4506 2.60402 11.5558 2.67661 11.5949L8.02433 14.4745C8.05393 14.4904 8.08955 14.4904 8.11915 14.4745L13.4669 11.5949C13.5395 11.5558 13.5362 11.4506 13.4614 11.4161L8.11365 8.94791C8.08706 8.93563 8.05642 8.93563 8.02983 8.94791Z",
    stroke: "#4C5E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02983 5.23362L6.20863 6.06821L2.68212 7.7018C2.60726 7.73635 2.60402 7.84155 2.67661 7.88064L8.02433 10.7602C8.05393 10.7761 8.08955 10.7761 8.11915 10.7602L13.4669 7.88064C13.5395 7.84155 13.5362 7.73635 13.4614 7.7018L9.93486 6.06821L8.11365 5.23362C8.08706 5.22135 8.05642 5.22135 8.02983 5.23362Z",
    stroke: "#4C5E6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02983 1.51934L2.68212 3.98751C2.60726 4.02206 2.60402 4.12727 2.67661 4.16636L8.02433 7.0459C8.05393 7.06183 8.08955 7.06183 8.11915 7.0459L13.4669 4.16636C13.5395 4.12727 13.5362 4.02206 13.4614 3.98751L8.11365 1.51934C8.08706 1.50706 8.05642 1.50706 8.02983 1.51934Z",
    stroke: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGrcPlatforms);
export default __webpack_public_path__ + "static/media/icons-grc-platforms.07e1d38e.svg";
export { ForwardRef as ReactComponent };